<template>
  <div>
    <j-modal :visible.sync="visible" switchFullscreen :width="'90%'" @cancel="close()" :maskClosable="false"
      :destroyOnClose="true" onOk="handleOk" :footer="null">
      <div slot="title">
        <a-icon type="question-circle" theme="twoTone" @click="showUnitInfo" />
        <a-button v-if="currentMedia.mediaType==10" v-has="'live:start'" @click="startLive(currentMedia.id)"
          type="danger" icon="play-circle">开播</a-button>

      </div>
      <a-spin v-if="loading" tip="加载中..." style="display: block; margin: 50px auto"></a-spin>
      <a-row v-else :gutter="24">
        <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <div class="video-area" id="media-content">
            <!-- 课程视频 -->
            <video v-if="videoUrl" oncontextmenu="return false;" controlsList="nodownload noremote footbar"
              :src="videoUrl" controls="true" @canplay="handleVideoInit" @play="handleVideoPlay"></video>

            <div v-show="pullUrl">
              <video id="player-container-id" preload="auto" playsinline webkit-playsinline></video>
            </div>

            <!-- 富文本 -->
            <a-icon v-if="mediaContent" class="download-media-content-icon" type="download"
              @click="downloadMediaContent" />
            <div ref="html2canvas" v-if="mediaContent" v-html="mediaContent"></div>
          </div>
        </a-col>
        <a-divider v-if="_isMobile()" />
        <a-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="unit-list">
            <a-timeline v-if="media">
              
                <a-icon v-if="media.mediaType == 5" slot="dot" type="edit" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 1" slot="dot" type="play-circle" style="font-size: 16px" />
                <a-icon v-if="media.mediaType == 3" slot="dot" type="snippets" style="font-size: 16px" />
                <a-collapse v-if="media.mediaPath && media.mediaPath.includes(',')" defaultActiveKey="1">
                  <a-collapse-panel key="1" :header="media.mediaName"
                    :style="{ backgroundColor: '#e2edff' }">
                    <a-button style="display: block; margin-bottom: 5px; width: 100%" size="small"
                      v-for="(val, i) in media.mediaPath_fileinfo" :key="i" @click="changeMedia(media, val.key)"
                      :type="currentMediaIndex == 0 && currentMediaFile == val.key ? 'primary' : 'default'">
                      {{ val.fileName }}<a-icon type="right" />
                    </a-button>
                  </a-collapse-panel>
                </a-collapse>
                <a-button v-else block @click="changeMedia(media, null)"
                  type="primary">
                  {{ media.mediaName }}<a-icon type="right" />
                </a-button>
             
              
            </a-timeline>
            <!-- <a-card v-if="unit.unitIntro" size="small" title="课程说明">
              <div v-html="unit.unitIntro ? unit.unitIntro.replace(/\n/g,'<br>') : ''"></div>
            </a-card> -->
          </div>
        </a-col>
      </a-row>
      <a-modal :width="'800px'" :visible="unitInfoVisible" :title="unit.unitName" :destroyOnClose="true" :footer="null"
        @cancel="unitInfoVisible = false">
        <div v-html="unit.unitIntro"></div>
      </a-modal>
    </j-modal>
  </div>
</template>
<script>
// import '@/components/jeecg/JModal'
import {getAction, postAction} from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { getQiniuUrl, getQiniuFile } from '@/utils/qiniu.js'
import html2canvas from 'html2canvas'
import { saveAs } from 'file-saver'
import TCPlayer from 'tcplayer.js';
import 'tcplayer.js/dist/tcplayer.min.css';
import { Modal } from 'ant-design-vue';
var QRCode = require('qrcode')
var canvas = ''


export default {
  name: 'MediaViewModal',
  mixins: [mixinDevice],
  components:{
    // LiveControl
  },
  data() {
    return {
      visible: false,
      vipVisible: false,
      createLoading: false,
      buyVisible: false,
      isModalVisible: false,
      shareCode: '',
      validDate: '',
      mediaId: '',
      media: {},
      vipLevel:{},
      payUrl: '',
      confirmLoading: false,
      loading: false,
      unitInfoVisible: false,
      unit: {},
      videoUrl: '',
      departId: '',
      pullUrl: '',
      pushUrl: '',
      streamName: '',
      mediaList: [],
      url: {
        unitMedia: '/teaching/teachingCourseUnit/getOneMedia',
      },
      mediaContent: '',
      currentMedia: {},
      currentMediaIndex: 0,
      currentMediaFile: 0,
      tcplayer: null
    }
  },
  created() {
  },
  mounted() {
    // contextmenu 禁用右键菜单
    document.addEventListener('contextmenu', function (e) {
      e.preventDefault()
    })
    // //禁止复制  selectstart
    // document.addEventListener('selectstart',function(e){
    //     e.preventDefault();
    // })
  },
  destroyed(){
    if(this.tcplayer){
        this.tcplayer.dispose()
    }
  },
  methods: {
    getQiniuUrl,
    getQiniuFile,
    startLive(id){
      this.$live({id}).startLive()
    },
    close(){
      
      this.visible = false
    },
    showUnitInfo() {
      this.unitInfoVisible = true
    },
    view(media) {
      this.visible = true
      console.log(media)
      this.currentMediaIndex = 0
      this.media = media
      this.currentMedia = media
      console.log()
    },
    getOneMedia(mediaId){
      this.visible = true
      getAction(this.url.unitMedia, { id: mediaId }).then(res =>{
          console.log(res.result)
          this.media = res.result
          this.currentMedia = this.media
          this.currentMediaIndex = 0
          this.changeMedia(this.media, null)
        })
    },
    changeMedia(media, mediaFile) {
      console.log("调用了")
      if(!mediaFile && media.mediaPath && media.mediaPath_fileinfo && media.mediaPath_fileinfo[0]){
        mediaFile = media.mediaPath_fileinfo[0].key
      }
      if([1,7,10].includes(media.mediaType)){
        this.mediaContent = ''
        this.videoUrl = ''
        this.pullUrl = ''
        if(this.pullUrl && this.tcplayer){
          this.tcplayer.ready(function(){
              this.tcplayer.pause()
          })
        }
      }
      this.currentMedia = media
      this.currentMediaFile = mediaFile
      let url
      if (media.mediaPath!= '' && media.mediaPath.includes(',')) {
        if (mediaFile) {
          url = this.searchObjByKey(media.mediaPath_fileinfo, 'key', mediaFile)['url']
        } else {
          url = media.mediaPath_fileinfo[0]['url']
          this.currentMediaFile = media.mediaPath_fileinfo[0]['key']
        }
      } else {
        url = media.mediaPath_url
      }

      console.log('changeMedia', media, mediaFile, url)
      switch (media.mediaType) {
        case 1: //教学视频
          if (url.endsWith('.mp4')) {
            this.videoUrl = url;
          } else {
              window.open(url, '_blank'); // 非 mp4 文件执行 window.open 打开新窗口
            }
          break
        case 3: //课堂练习
        case 5: //课后作业
          this.handleViewCode(media, mediaFile)
          break
        case 6: //PPT
          // if(media.mediaPath_url.endsWith('ppt') || media.mediaPath_url.endsWith('pptx') ){
          window.open(`/fileView?url=` + encodeURIComponent(btoa(url)))
          // }else{
          // window.open(media.mediaPath_url)
          // }
          break
        case 7: //富文本
          this.mediaContent = media.mediaContent
          break
        case 8: //OJ
          window.open('/onlinecode/index.html?questionId=' + media.questionId)
          break
        case 10: //直播
          this.getLiveDetail()
          break
        default:
          window.open(url)
      }
    },
    getLiveDetail(){
      let that = this
      getAction('/teaching/broadcast/getRoomDetail?mediaId=' + this.currentMedia.id).then(res=>{
        if(!res.success){
          this.$message.error(res.message)
          return
        }
        this.pullUrl = res.result.pullURL
        this.pushUrl = res.result.pushURL
        this.streamName = res.result.streamName
        console.log('tcplayerUrl', this.pullUrl);
        this.setVideoSrc(that.pullUrl)
      })
    },
    setVideoSrc(url){
      let that = this
      if(this.tcplayer){
          this.tcplayer.ready(function(){
            that.tcplayer.src(url)
          })
        }else{
          this.tcplayer = TCPlayer('player-container-id', {
            sources: [{
              src: url, // 播放地址
              autoplay: true
            }],
            controlBar:{
            }
          });
          this.tcplayer.on('error', function(error){
            console.log('tcplayerError', error.data.code, error);
            switch(error.data.code){
            }
          })
          this.tcplayer.on('webrtcevent', function(event) {
              // 从回调参数 event 中获取事件状态码及相关数据
              // https://cloud.tencent.com/document/product/881/30820
              console.log('webrtcevent', event.data.code, event);
              switch(event.data.code){
                case 1001: //开始拉流 
                case 1002: //已经链接服务器
                case 1003: //视频播放开始
                case 1004: //停止拉流
                case 1005: //链接服务器失败，自动重连
                case 1006: //拉流数据为空
                case 1009: //拉流卡顿等待缓冲
                case 1010: //拉流卡顿结束↩️播放
              }
          });
        }
    },
    searchObjByKey(list, key, value) {
      for (let i = 0; i < list.length; i++) {
        if (list[i][key] == value) {
          return list[i]
        }
      }
      return {}
    },
    handleVideoInit() {
      console.log('video init')
    },
    handleVideoPlay() {
      console.log('play')
    },
    handleVideoPause() {
      console.log('pause')
    },
    handleVideoEnded(e) {
      console.log('ended')
      let duration = e.target.duration
      this.currentMedia.finished = true
    },
    handleViewCode(media, mediaFile) {
      switch (media.codeType) {
        case 1:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 2:
          window.open(
            '/scratch3/index.html?scene=twl&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 3:
          return window.open('/scratchjr/editor.html?mode=edit&filepath=' + media.mediaPath_url.split(',')[mediaFile])
          break
        case 4:
          return window.open(
            '/onlinecode/index.html?lang=turtle&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 5:
          return window.open(
            '/onlinecode/index.html?lang=python&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 6:
          return window.open(
            '/onlinecode/index.html?lang=c&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 7:
          return window.open(
            '/onlinecode/index.html?lang=cpp&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        case 8:
          return window.open(
            '/onlinecode/index.html?lang=java&unitId=' +
              this.unit.id +
              '&mediaId=' +
              media.id +
              '&workName=' +
              media.mediaName +
              '&mediaFile=' +
              mediaFile
          )
          break
        default:
          window.open(this.getQiniuFile(media.mediaPath_url))
      }
    },
    downloadMediaContent() {
      let that = this
      let contentDom = document.getElementById('media-content')
      contentDom.scrollTop = 0
      html2canvas(this.$refs.html2canvas, {
        backgroundColor: 'white',
        useCORS: true, // 解决文件跨域问题
        height: contentDom.scrollHeight,
        windowHeight: contentDom.scrollHeight,
      }).then((canvas) => {
        const url = canvas.toDataURL('image/png') // 生成的图片
        saveAs(url, that.unit.unitName + '-' + that.currentMedia.mediaName + '.png')
      })
    },
  },
}
</script>
<style lang="less" scoped>
.video-area {
  .tcplayer {
    width: 100%;
    min-height: 480px;
  }
  max-height: 700px;
  min-height: 480px;
  overflow: auto;
  video {
    width: 100%;
    min-height: 480px;
  }
}
.unit-list {
  vertical-align: top;
  padding: 10px;
  margin: 0 20px;
  max-height: 700px;
  overflow-y: auto;
  /deep/.ant-btn {
    text-align: left;
  }
}

.download-media-content-icon {
  opacity: 1;
  color: black;
  font-size: 24px;
  line-height: 24px;
  position: absolute;
  top: 2px;
  right: 24px;
  z-index: 9;
  cursor: pointer;
  transition: opacity 0.3s;
}
.payment-info {
  margin: 16px 0;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
}

.vip-level,
.vip-price {
  display: block;
  margin-bottom: 8px;
}

.qr-code-container {
  border: 1px solid #f5f5f5;
  height: 300px;
  width: 70%;
  margin: 0 auto;
  padding: 16px;
  box-sizing: border-box;
}

.qr-code-header {
  text-align: center;
  margin-bottom: 16px;
}

.wx-logo {
  width: 100px;
  height: 25px;
}

.qr-code-body {
  text-align: center;
}
.custom-modal {
    position: relative; /* 使模态框的定位上下文为相对定位 */
    top: 5%;
    height: 85%;
    overflow-y: hidden;
  }
  .modal-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between; /* 将内容区域分布在顶部和底部 */
  }
  .button-container {
    display: flex;
    justify-content: center; /* 按钮容器水平居中 */
    margin-bottom: 16px; /* 距离底部的距离 */
  }
  .membership-button {
    color: orange;
  }
</style>
